"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var create_apollo_client_1 = __importDefault(require("./create-apollo-client"));
function default_1(additionalHeaders) {
    if (additionalHeaders === void 0) { additionalHeaders = {}; }
    var domain = process.env.PERMANENT_DOMAIN || window.permanentDomain || '';
    var llaShop = 'hbus';
    if (domain.startsWith('hbca-launched'))
        llaShop = 'hbca';
    else if (domain.startsWith('tiller-and-hatch'))
        llaShop = 'th';
    else if (domain.includes('test'))
        llaShop = 'hbtest';
    var headers = Object.assign({ 'X-lla-shop': llaShop, 'x-api-key': process.env.SUBLESS_API_KEY || 'dev-api-key' }, additionalHeaders);
    return (0, create_apollo_client_1.default)({
        uri: process.env.SUBLESS_API_URI || 'http://localhost:3300/graphql',
        // uri: 'http://localhost:3300/graphql',
        headers: headers,
    });
}
exports.default = default_1;
